import { LogicalOperator, SearchFilterOperator } from './FilterDefinition';

export type FilterField = {
  filter?: FilterGroup;
  id: string;
  operator?: '' | SearchFilterOperator;
  propertyName?: string;
  value?: boolean | string;
};

export type FilterGroup = {
  fields: FilterField[];
  isRootLevelFilter: boolean;
  logicalOperator: LogicalOperator;
};

// Without ID (for server-side and URL)
export type FilterFieldWithoutId = Omit<FilterField, 'filter' | 'id'> & {
  filter?: FilterGroupWithoutId;
};

export type FilterGroupWithoutId = Omit<FilterGroup, 'fields'> & {
  fields: FilterFieldWithoutId[];
};

export type MinifiedFilterField = {
  f?: MinifiedFilterGroup;
  op: SearchFilterOperator;
  pn: string;
  v?: boolean | string;
};

export type MinifiedFilterGroup = {
  /**
   * fields
   */
  f: MinifiedFilterField[];
  /**
   * logicalOperator
   */
  lo: LogicalOperator;
  /**
   * Numeric representation of boolean isRootLevelFilter value
   */
  r: number;
};

export const MinifiedFilterFieldKeyMap: Record<
  keyof Omit<FilterField, 'id'>,
  keyof MinifiedFilterField
> = {
  filter: 'f',
  operator: 'op',
  propertyName: 'pn',
  value: 'v',
};

export const MinifiedFilterGroupKeyMap: Record<keyof FilterGroup, keyof MinifiedFilterGroup> = {
  fields: 'f',
  logicalOperator: 'lo',
  isRootLevelFilter: 'r',
};
